import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import 'lxgw-wenkai-screen-webfont/lxgwwenkaiscreen.css';
import './index.css';

if ((window as { claudio?: { isElectron?: boolean } }).claudio?.isElectron) {
  document.documentElement.classList.add('is-electron');
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // updateViaCache none: SW脚本更新永远绕过HTTP缓存 — 旧SW卡住整个应用壳的事故不能重演
    navigator.serviceWorker
      .register('/sw.js', { updateViaCache: 'none' })
      .then((reg) => {
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) void reg.update().catch(() => {});
        });
      })
      .catch(() => {});
  });
}

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
